export default function () {
  /**
   * Handle adding an Accent line to MembershipBanner blocks
   */
  function setupLines() {
    const accents = document.querySelectorAll('.js-hotel-membership-banner__accent');

    for(let accent of accents) {
      const nextSlider = accent.parentNode.nextElementSibling.querySelector('.js-hotel-carousel')

      const pricingWrapper = accent.querySelector('.c-hotel-membership-banner__pricing');

      if (nextSlider && pricingWrapper) {
        const sliderRect = nextSlider.getBoundingClientRect();
        const pricingRect = pricingWrapper.getBoundingClientRect();

        const diffHeight = Math.abs(sliderRect.top - pricingRect.bottom + 60);

        const accent = document.createElement('div');
        accent.style.height = `${diffHeight}px`;
        accent.classList.add('c-hotel-membership-banner__accent');
        accent.appendChild(document.createElement('span'));

        const existingAccent = pricingWrapper.querySelector('.c-hotel-membership-banner__accent');
        if (existingAccent) {
          existingAccent.remove();
        }

        pricingWrapper.appendChild(accent);
      }
    }
  }


  document.addEventListener('DOMContentLoaded', function () {
    setupLines()

    let timer;
    window.addEventListener('resize', function () {
      clearTimeout(timer);

      timer = setTimeout(setupLines, 100);
    });
  });
}
